// extracted by mini-css-extract-plugin
export default {"header":"D3Veh ZdH1P","withShadow":"fIiIT","left":"O7S6f","iconSearch":"ZvbIj","userMenu":"wjxLZ"};